import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { About } from '../../portfolio.data';
import { RevealDirective } from '../../directives/reveal.directive';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, RevealDirective],
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent {
  @Input({ required: true }) about!: About;
}
